import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'glass-half-full',
  template: require('./glass-half-full.component.html'),
  styles: [require('./../blog.component.scss'), require('./glass-half-full.component.scss')]
})
export class GlassHalfFullComponent extends BlogPage {
  title = "Seeing the Glass Half Full in Shipping's Murky Waters - Linescape";
  description = "You would think new investment in America’s infrastructure would mean a rosier outlook for the shipping industry. But many are unsure whether to see the glass half full or half empty.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/glass-half-full/glass-half-full.component.ts